import { PopperBase } from './popper-base';
import { LineCalendarCell, LineSelectedCell } from "../model";
import { PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE } from 'apps/events';
import PopperJS from 'popper.js';

class CreateSchedule extends PopperBase {
  init(){
    super.init();
    this.watchPlannerData('createSchedule', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeCreateSchedule(newVal, oldVal, objectPath)});
  }

  onChangeCreateSchedule(selectedCell: LineSelectedCell, oldVal, objectPath) {
    if(selectedCell === null) {
      this.hide();
    } else {
      this.show(selectedCell);
    }
  }
  hide(){
    if(!this.isShow){ return; }
    this.isShow = false;
    this.update();
  }
  show(selectedCell: LineSelectedCell){
    this.isShow = true;
    let popper = new PopperJS(
      selectedCell.element,
      this.querySelector('.popper'),
      this.getPopperOptions()
    );
    this.update();
  }
  onClose(){
    let e = new CustomEvent(PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE, {});
    document.dispatchEvent(e);
  }
}
let scope = 'orders.planner.dialog.create-schedule';
riot.mixin(scope, CreateSchedule as riot.TagMixin);
